import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

export default function FounderNote() {
  return (
    <section className="relative container-x py-24 md:py-32" data-testid="founder-note">
      <div className="absolute inset-0 bg-[radial-gradient(60%_60%_at_20%_40%,rgba(0,198,174,0.08),transparent_60%)] pointer-events-none" />
      <Reveal className="relative z-10 grid md:grid-cols-[240px_1fr] gap-10 md:gap-14 max-w-5xl">
        <div className="flex md:flex-col items-start gap-4">
          <div className="w-20 h-20 md:w-28 md:h-28 rounded-3xl glass grid place-items-center shrink-0 shadow-[0_0_40px_rgba(0,198,174,0.35)] overflow-hidden">
            <img src="/brand/gatemate-logo-512.webp" alt="GateMate logo" className="w-full h-full object-cover" />
          </div>
          <div>
            <p className="overline mb-1">Founder note</p>
            <p className="font-display text-lg font-bold text-white">Dominique Hilliard</p>
            <p className="text-xs text-zinc-500">Founder · Dallas, TX</p>
          </div>
        </div>

        <div className="space-y-5 text-zinc-300 leading-relaxed text-[17px]">
          <p>
            I built GateMate because <span className="text-white font-semibold">I was standing in a room full of strangers who could've been friends</span> — and none of us knew it. A concert in Deep Ellum. A rooftop in Uptown. A flight to nowhere in particular. The people were already there. Social media just made us stare at our phones instead of each other.
          </p>
          <p>
            GateMate flips it. <span className="text-neon-cyan">The room is the network.</span> When you check into a GateRoom, the room becomes legible for a few hours — you see who else is here, what they're into, who else showed up alone. Then the room closes. Nothing sticky. No feed. No highlight reel to compare yourself to. Just presence.
          </p>
          <p>
            We're starting in Dallas-Fort Worth because this is where I live and where I can walk into any venue and ask a stranger if this feels right. Airport GateRooms are already live at seven airports — DFW and Love Field at home, plus Sea-Tac, Austin, Houston, San Antonio and El Paso. Then the next city. But we're doing this <span className="italic">one room at a time</span>, not one growth-hack at a time.
          </p>
          <p className="pt-2">
            <Link
              to="/about"
              data-testid="founder-note-more"
              className="inline-flex items-center gap-1.5 text-neon-cyan hover:text-white transition-colors text-sm font-semibold"
            >
              The full manifesto <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </p>
        </div>
      </Reveal>
    </section>
  );
}
